<hr class="sp-width__full sp-stroke sp-stroke__dashed-dark sp-margin__bottom" />
<div class="sp-row__end sp-wrap">
  <div
    *ngFor="let key of getFiltersKeys()"
    class="sp-margin__left sp-margin__bottom">
    <app-shared-pill
      content="{{ getLabelByKey(key) | translate }}: {{ getContentByKey(key) }}"
      [content_class]="'sp-color__accent-contrast'"
      [pill_class]="'sp-background__accent'"
      [is_clear_enabled]="true"
      (clear_click)="onFilterClear(key)"></app-shared-pill>
  </div>
</div>
<hr class="sp-width__full sp-stroke sp-stroke__dashed-dark" />
